import storeBaseRouteSelector from './store_base_route_selector.js'
import storeSearchSelector from './store_search_selector.js'
import storeSearchResultsSelector from 'redux/selectors/store/store_search_results_selector'
import storeFilterSelector from './store_filter_selector.js'
import storeCarouselSelector from './store_carousel_selector.js'
import storeBreadcrumbSelector from './store_breadcrumb_selector.js'
import storeLandingContainerSelector from './store_landing_container_selector'
import storeSearchContainerSelector from './store_search_container_selector'
import storeFolderContainerSelector from './store_folder_container_selector'
import storeWidgetsSelector from './store_widgets_selector.js'
import storeSearchPerformSearchSelector from './store_search_perform_search_selector'
import storeFolderPerformSearchSelector from './store_folder_perform_search_selector'
import storeFilterSidebarSelector from './store_filter_sidebar_selector'
import storeFilterSearchDelaySelector from './store_filter_search_delay_selector.js'
import storeLockedContentSelector from './store_locked_content_selector.js'
import storePreviewContainerSelector from './store_preview_container_selector.js'
import storeAddToPrivateLibrarySelector from './store_add_to_private_library_selector.js'
import storeNewRouteRedirection from './store_new_route_redirection.js'
import storeActivityBanks from './store_activity_banks_selector.js'

export default {
	storeBaseRouteSelector,
	storeSearchSelector,
	storeSearchResultsSelector,
	storeFilterSelector,
	storeCarouselSelector,
	storeBreadcrumbSelector,
	storeLandingContainerSelector,
	storeSearchContainerSelector,
	storeFolderContainerSelector,
	storeWidgetsSelector,
	storeSearchPerformSearchSelector,
	storeFolderPerformSearchSelector,
	storeFilterSidebarSelector,
	storeFilterSearchDelaySelector,
	storeLockedContentSelector,
	storePreviewContainerSelector,
	storeAddToPrivateLibrarySelector,
	storeNewRouteRedirection,
	storeActivityBanks,
}
